module.exports = __webpack_public_path__ + "img/sina-video3.382d61a5.jpg";